import { useState,useEffect} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useNavigate } from 'react-router-dom';

import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { EffectFade, Navigation, Pagination ,Autoplay } from 'swiper/modules';


const  ComedySwiper = ({homeSlider,homeSliderError}) =>  {
  
          const [data,setData] = useState(homeSlider)
          const [error,setError] = useState(homeSliderError)   
          const [loading,setLoading]= useState(false)
          const [hydrating,setHydrating]=useState(true)
          const navigate = useNavigate()

          function  navigateTo(url) {

              navigate(url)
              
          }
          
          
          useEffect(()  => {
             
                  const t= setTimeout(() => {
                     setHydrating(false)
                  }, 500);
          
                  return () => clearTimeout(t)
          
               },[])

              
                  useEffect(()  =>   {
                        
                       if (data) {
              
                         setLoading(false)
                         return;
                       }

   
                          const fetchData = async() => {
                              try {
                                
                                const res= await fetch(`https://www.teluguone.com/comedy/comedyHomeSliderJson.php?start=0&limit=3`)
                                if (!res.ok) throw new Error(`Response Was Not Ok`)
                                const result = await res.json()
                               setData(result.comedy_slider)
                                setError(null)
                                setLoading(false)
                                
                              } catch (error) {
                                 setData(null)
                                 setError(error.message)
                                 setLoading(false)
                              }
                          }
                           setData(null)
                           setLoading(true)
                           fetchData()
                       
              
                  },[])
              

          
           

          return (
            <div className='comedy-swiper'>
              {!error && <Swiper
                spaceBetween={30}
                effect={'fade'}
                navigation={true}
                pagination={{ clickable: true }}
                loop={true}
                autoplay={{ delay: 3000 }}  
                modules={[EffectFade, Navigation, Pagination, Autoplay]}
                className="mySwiper"
              >
              

              {
               (loading || hydrating) &&  <SwiperSlide>
                <img alt="slider-image" loading ='eager' fetchpriority='high' src='/comedy/assets/images/error_img.webp' />
               </SwiperSlide>
                      
              }

               {  
                data && data.map((item,index) =>
                         <SwiperSlide className={`${hydrating ? 'ssr-hidden' : ''}`} onClick={() => navigateTo(item.url_link ? item.url_link : '/')} key={index} >
                          <img alt="slider-image" loading ={index === 0 ? 'eager' : 'auto'} fetchpriority={index ===0 ? 'high' : 'auto'} src={item.stimg ? item.stimg : '/comedy/assets/images/error_img.webp'} />
                        </SwiperSlide>)  
               }

              
              
              </Swiper>}
               {error &&  <div className="json-loading-error-div">
                      <img loading="eager" src="/comedy/assets/images/json_error.png" alt="json_error" />
              </div> }
            </div>
          );
}

export default ComedySwiper;